export enum FieldType {
  TEXT = "Text",
  NUMBER = "Number",
  DROPDOWN = "Dropdown",
  DATE = "Date",
  NUMBERRANGE = "Number-range"
}
